import { render, staticRenderFns } from "./SubcatTable.vue?vue&type=template&id=11dbec90&scoped=true&"
import script from "./SubcatTable.vue?vue&type=script&lang=js&"
export * from "./SubcatTable.vue?vue&type=script&lang=js&"
import style0 from "./SubcatTable.vue?vue&type=style&index=0&id=11dbec90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dbec90",
  null
  
)

export default component.exports